<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">Point Mapping Logs</h3>
            </v-card-title>
            <v-card-text>
                  <v-row>
                    <v-col md="6">
                      <v-text-field
                        solo
                        rounded
                        v-model="logsFilter.search_keyword"
                        label="Search ... "
                        color="#e60040"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        @click:clear="
                          (logsFilter.search_keyword = null), (logsPage = 1), getLogsData()
                        "
                        @keydown.enter="(logsPage = 1), getLogsData()"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col sm="3">
                      <v-autocomplete
                        solo
                        rounded
                        v-model="logsFilter.is_active"
                        :items="statuses"
                        clearable
                        @click:clear="(logsFilter.is_active = null), (logsPage = 1)"
                        label="Status"
                        @input="getLogsData"
                        prepend-inner-icon="mdi-toggle-switch"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="3">
                      <v-autocomplete
                        solo
                        rounded
                        v-model="logsFilter.position_id"
                        :items="positionItems"
                        clearable
                        @click:clear="(logsFilter.position_id = null), (logsPage = 1)"
                        label="Position"
                        @input="getLogsData"
                        prepend-inner-icon="mdi-account-group"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="3">
                      <v-autocomplete
                        solo
                        rounded
                        v-model="logsFilter.point_type"
                        :items="pointTypeItems"
                        clearable
                        @click:clear="(logsFilter.point_type = null), (logsPage = 1)"
                        label="Point Type"
                        @input="getLogsData"
                        prepend-inner-icon="mdi-star"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="3">
                      <v-autocomplete
                        solo
                        rounded
                        v-model="logsFilter.point_status"
                        :items="pointStatusItems"
                        clearable
                        @click:clear="(logsFilter.point_status = null), (logsPage = 1)"
                        label="Point Status"
                        @input="getLogsData"
                        prepend-inner-icon="mdi-flag"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="3">
                      <v-menu
                        v-model="month_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            rounded
                            v-model="logsFilter.month_year"
                            label="Year - Month"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            @click:clear="
                              () => {
                                logsFilter.month_year = null;
                                getLogsData();
                              }
                            "
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="logsFilter.month_year"
                          type="month"
                          @input="
                            getLogsData();
                            month_menu = false;
                          "
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="3">
                      <v-menu
                        v-model="start_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            rounded
                            v-model="logsFilter.start_date"
                            label="Start Date"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            @click:clear="
                              () => {
                                logsFilter.start_date = null;
                                getLogsData();
                              }
                            "
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="logsFilter.start_date"
                          @input="
                            getLogsData();
                            start_menu = false;
                          "
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="3">
                      <v-menu
                        v-model="end_menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            rounded
                            v-model="logsFilter.end_date"
                            label="End Date"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            @click:clear="
                              () => {
                                logsFilter.end_date = null;
                                getLogsData();
                              }
                            "
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="logsFilter.end_date"
                          @input="
                            getLogsData();
                            end_menu = false;
                          "
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-btn
                        rounded
                        large
                        class="primary"
                        @click="generateLogsExcel()"
                        :loading="isLogsExcelloading"
                      >
                        Generate Excel
                      </v-btn>
                    </v-col>
                  </v-row>
                  <section v-if="isLogsLoading" style="height: 285px">
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </section>
                  <v-simple-table
                    v-else
                    class="striped-table"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Sr. No.</th>
                          <th class="text-left">Status</th>
                          <th class="text-left">User</th>
                          <th class="text-left">Total Earned Points</th>
                          <th class="text-left">Used Points</th>
                          <th class="text-left">Total Available Points</th>
                          <th class="text-left">Date</th>
                          <th class="text-right action_th">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="point_mapping_logs && point_mapping_logs.length != 0">
                        <tr
                          v-for="(log, i) in point_mapping_logs"
                          :key="`log_${i}`"
                          :class="{
                            'table-row-even': i % 2 === 0,
                            'table-row-odd': i % 2 !== 0,
                            'table-row-last': point_mapping_logs.length - 1 == i,
                          }"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>
                            <v-tooltip bottom v-if="log.is_active == 1">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="teal"
                                  text-color="white"
                                >
                                  <v-avatar left>
                                    <v-icon size="15"
                                      >mdi-checkbox-marked-circle</v-icon
                                    >
                                  </v-avatar>
                                  Active
                                </v-chip>
                              </template>
                              <span>Active</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="log.is_active == 0">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="red"
                                  text-color="white"
                                >
                                  <v-avatar left>
                                    <v-icon size="15">mdi-close-circle</v-icon>
                                  </v-avatar>
                                  Inactive
                                </v-chip>
                              </template>
                              <span>Inactive</span>
                            </v-tooltip>
                          </td>
                          <td>
                            {{ log.user ? log.user.first_name + ' ' + (log.user.last_name || '') : "" }}
                          </td>
                          <td>{{ log.total_points || "0" }}</td>
                          <td>{{ log.used_points || "0" }}</td>
                          <td>{{ log.total_available_points || "0" }}</td>
                          <td>{{ log.created_at || "" }}</td>
                          <td class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  fab
                                  x-small
                                  color="primary"
                                  @click="viewUserLogs(log.user_id)"
                                >
                                  <v-icon dark>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              <span>View User Details</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="8" class="text-center">No data found</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-pagination rounded v-model="logsPage" :length="logsPaginationLength">
                  </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- User Logs Detail Dialog -->
      <v-dialog v-model="showUserLogsDialog" width="1200" scrollable>
        <v-card rounded="xxl">
          <v-card-title>
            <h3>User Point Mapping Details</h3>
            <v-spacer></v-spacer>
            <v-btn icon @click="showUserLogsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <section v-if="isUserLogsLoading" style="height: 285px">
              <v-progress-linear
                indeterminate
                color="primary"
              ></v-progress-linear>
            </section>
            <v-simple-table v-else class="striped-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr. No.</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">User</th>
                    <th class="text-left">Product</th>
                    <th class="text-left">Unit in Ltr</th>
                    <th class="text-left">Point Type</th>
                    <th class="text-left">Point Status</th>
                    <th class="text-left">Points</th>
                    <th class="text-left">Date</th>
                  </tr>
                </thead>
                <tbody v-if="user_specific_logs && user_specific_logs.length != 0">
                  <tr
                    v-for="(log, i) in user_specific_logs"
                    :key="`user_log_${i}`"
                    :class="{
                      'table-row-even': i % 2 === 0,
                      'table-row-odd': i % 2 !== 0,
                      'table-row-last': user_specific_logs.length - 1 == i,
                    }"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <v-tooltip bottom v-if="log.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="teal"
                            text-color="white"
                          >
                            <v-avatar left>
                              <v-icon size="15"
                                >mdi-checkbox-marked-circle</v-icon
                              >
                            </v-avatar>
                            Active
                          </v-chip>
                        </template>
                        <span>Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="log.is_active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="red"
                            text-color="white"
                          >
                            <v-avatar left>
                              <v-icon size="15">mdi-close-circle</v-icon>
                            </v-avatar>
                            Inactive
                          </v-chip>
                        </template>
                        <span>Inactive</span>
                      </v-tooltip>
                    </td>
                    <td>
                      {{ log.user ? log.user.first_name + ' ' + (log.user.last_name || '') : "" }}
                    </td>
                    <td>
                      {{ log.product ? log.product.name : "" }}
                    </td>
                    <td>{{ log.unit_in_liter || "0" }}</td>
                    <td>
                      <v-chip
                        small
                        outlined
                        :color="getPointTypeColor(log.point_type)"
                        class="font-weight-medium"
                      >
                        {{ getPointTypeLabel(log.point_type) }}
                      </v-chip>
                    </td>
                    <td>
                      <v-chip
                        small
                        outlined
                        :color="getPointStatusColor(log.point_status)"
                        class="font-weight-medium"
                      >
                        {{ getPointStatusLabel(log.point_status) }}
                      </v-chip>
                    </td>
                    <td>{{ log.point || "0" }}</td>
                    <td>{{ log.created_at || "" }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-pagination rounded v-model="userLogsPage" :length="userLogsPaginationLength">
            </v-pagination>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "PointMappingsPage",
  data() {
    return {
      logsFilter: {
        search_keyword: "",
        is_active: "",
        position_id: "",
        point_type: "",
        point_status: "",
        month_year: "",
        start_date: "",
        end_date: "",
        user_id: "",
      },
      point_mapping_logs: [],
      user_specific_logs: [],
      positionItems: [],
      pointTypeItems: [
        { id: 0, text: "All Types", value: "" },
        { id: 1, text: "Earned - Sale", value: "1" },
        { id: 2, text: "Earned - Enquiry Bonus", value: "2" },
        { id: 3, text: "Booster Driver Point", value: "3" },
        { id: 4, text: "Welcome Bonus", value: "4" },
        { id: 5, text: "KYC Point", value: "5" },
        { id: 6, text: "Field Hero Rewards", value: "6" },
        { id: 7, text: "Gift Redeem", value: "7" },
      ],
      pointStatusItems: [
        { id: 0, text: "All Status", value: "" },
        { id: 1, text: "Point Earned", value: "0" },
        { id: 2, text: "Point Used", value: "1" },
        { id: 3, text: "Point Earned Return", value: "2" },
        { id: 4, text: "Point Used Return", value: "3" },
      ],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      logsPage: 1,
      userLogsPage: 1,
      logsPaginationLength: 0,
      userLogsPaginationLength: 0,
      logsCount: 0,
      userLogsCount: 0,
      isLogsLoading: false,
      isUserLogsLoading: false,
      isLogsExcelloading: false,
      showUserLogsDialog: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
    };
  },
  watch: {
    logsPage: "getLogsData",
    userLogsPage: "getUserLogsData",
  },
  mounted() {
    this.getLogsMasters();
    this.getLogsData();
  },
  methods: {
    async getLogsMasters() {
      await axios
        .get(`point_mapping_logs/masters`)
        .then((masters) => {
          masters = masters.data;
          this.positionItems = [
            {
              id: 0,
              text: "Select Position",
              value: "",
            },
          ];
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getLogsData() {
      this.isLogsLoading = true;
      this.logsFilter.search_keyword = this.logsFilter.search_keyword
        ? this.logsFilter.search_keyword
        : "";
      this.logsFilter.is_active = this.logsFilter.is_active
        ? this.logsFilter.is_active
        : "";
      this.logsFilter.position_id = this.logsFilter.position_id
        ? this.logsFilter.position_id
        : "";
      this.logsFilter.point_type = this.logsFilter.point_type
        ? this.logsFilter.point_type
        : "";
      this.logsFilter.point_status = this.logsFilter.point_status
        ? this.logsFilter.point_status
        : "";
      this.logsFilter.month_year = this.logsFilter.month_year
        ? this.logsFilter.month_year
        : "";
      this.logsFilter.start_date = this.logsFilter.start_date
        ? this.logsFilter.start_date
        : "";
      this.logsFilter.end_date = this.logsFilter.end_date
        ? this.logsFilter.end_date
        : "";

      let query =
        "page=" +
        this.logsPage +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.logsFilter.is_active +
        "&position_id=" +
        this.logsFilter.position_id +
        "&point_type=" +
        this.logsFilter.point_type +
        "&point_status=" +
        this.logsFilter.point_status +
        "&start_date=" +
        this.logsFilter.start_date +
        "&end_date=" +
        this.logsFilter.end_date +
        "&month_year=" +
        this.logsFilter.month_year +
        "&search_keyword=" +
        this.logsFilter.search_keyword;

      await axios
        .get(`point_mapping_logs?${query}`)
        .then((response) => {
          this.point_mapping_logs = response.data.data;
          this.logsCount = response.data.count;
          this.logsPaginationLength = Math.ceil(this.logsCount / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLogsLoading = false;
    },
    async getUserLogsData(userId = null) {
      if (!userId && !this.logsFilter.user_id) return;

      this.isUserLogsLoading = true;
      const targetUserId = userId || this.logsFilter.user_id;

      let query =
        "page=" +
        this.userLogsPage +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&user_id=" +
        targetUserId;

      await axios
        .get(`point_mapping_logs?${query}`)
        .then((response) => {
          this.user_specific_logs = response.data.data;
          this.userLogsCount = response.data.count;
          this.userLogsPaginationLength = Math.ceil(this.userLogsCount / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isUserLogsLoading = false;
    },
    viewUserLogs(userId) {
      this.logsFilter.user_id = userId;
      this.userLogsPage = 1;
      this.showUserLogsDialog = true;
      this.getUserLogsData(userId);
    },
    async generateLogsExcel() {
      this.isLogsExcelloading = true;
      this.logsFilter.search_keyword = this.logsFilter.search_keyword
        ? this.logsFilter.search_keyword
        : "";
      this.logsFilter.is_active = this.logsFilter.is_active
        ? this.logsFilter.is_active
        : "";
      this.logsFilter.position_id = this.logsFilter.position_id
        ? this.logsFilter.position_id
        : "";
      this.logsFilter.point_type = this.logsFilter.point_type
        ? this.logsFilter.point_type
        : "";
      this.logsFilter.point_status = this.logsFilter.point_status
        ? this.logsFilter.point_status
        : "";
      this.logsFilter.month_year = this.logsFilter.month_year
        ? this.logsFilter.month_year
        : "";
      this.logsFilter.start_date = this.logsFilter.start_date
        ? this.logsFilter.start_date
        : "";
      this.logsFilter.end_date = this.logsFilter.end_date
        ? this.logsFilter.end_date
        : "";

      let query =
        "role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.logsFilter.is_active +
        "&position_id=" +
        this.logsFilter.position_id +
        "&point_type=" +
        this.logsFilter.point_type +
        "&point_status=" +
        this.logsFilter.point_status +
        "&start_date=" +
        this.logsFilter.start_date +
        "&end_date=" +
        this.logsFilter.end_date +
        "&month_year=" +
        this.logsFilter.month_year +
        "&search_keyword=" +
        this.logsFilter.search_keyword;

      let response = await axios.get(`/point_mapping_logs/excel_export?${query}`);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
      this.isLogsExcelloading = false;
    },
    getPointTypeLabel(pointType) {
      const types = {
        1: 'Sale',
        2: 'Enquiry Bonus',
        3: 'Booster Driver',
        4: 'Welcome Bonus',
        5: 'KYC',
        6: 'Field Hero',
        7: 'Gift Redeem',
      };
      return types[pointType] || 'Unknown';
    },
    getPointTypeColor(pointType) {
      const colors = {
        1: '#1976D2',      // Professional Blue
        2: '#7B1FA2',      // Deep Purple
        3: '#F57C00',      // Dark Orange
        4: '#388E3C',      // Professional Green
        5: '#0097A7',      // Cyan
        6: '#303F9F',      // Indigo
        7: '#C2185B',      // Pink
      };
      return colors[pointType] || '#757575';
    },
    getPointStatusLabel(pointStatus) {
      const statuses = {
        0: 'Earned',
        1: 'Used',
        2: 'Earned Return',
        3: 'Used Return',
      };
      return statuses[pointStatus] || 'Unknown';
    },
    getPointStatusColor(pointStatus) {
      const colors = {
        0: '#388E3C',      // Green
        1: '#D32F2F',      // Red
        2: '#F57C00',      // Orange
        3: '#1976D2',      // Blue
      };
      return colors[pointStatus] || '#757575';
    },
  },
};
</script>
